<template>
  <div class="view">
    <img src="../assets/park/top_back.png" class="top_back_img" />
    <div class="top_back_num">
      <el-row
        :gutter="10"
        type="flex"
        justify="center"
        style="width: 1530px; margin: auto; height: 146px"
      >
        <el-col :xs="16" :sm="16" :md="8">
          <div class="border">
            <div class="border_title">
              <div class="border_title_one">30</div>
              <div class="border_title_two">+</div>
            </div>
            <div class="border_content">覆盖的城市</div>
          </div>
        </el-col>
        <el-col :xs="16" :sm="16" :md="8">
          <div class="border">
            <div class="border_title">
              <div class="border_title_one">3</div>
              <div class="border_title_two">万+</div>
            </div>
            <div class="border_content">已管理智能化车位</div>
          </div>
        </el-col>
        <el-col :xs="16" :sm="16" :md="8">
          <div class="border">
            <div class="border_title">
              <div class="border_title_one">100</div>
              <div class="border_title_two">万+</div>
            </div>
            <div class="border_content">服务注册用户</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div id="系统架构" class="solve head-label">
      <el-divider direction="horizontal"></el-divider>
      <div class="title">解决方案</div>
      <div class="sub_title">城市级智慧停车全场景架构图</div>
    </div>
    <div class="solve_content">
      <img src="../assets/park/system_framework.png" class="system_framework_img" />
    </div>
    <div class="pay_process">
      <div class="pay_process_back">
        <div id="收费流程" class="head-label">
          <div class="sub_title">路侧车位AI值守收费</div>
        </div>
        <el-tabs v-model="tabName">
          <el-tab-pane label="AI系统值守" name="first">
            <img src="../assets/park/duty_charge.png" class="duty_charge_img" />
          </el-tab-pane>
          <el-tab-pane label="车主使用流程" name="second">
            <img src="../assets/park/stop_process.png" class="stop_process_img" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div id="充电车位" class="charge_seat">
      <img src="../assets/park/seat_manage.png" class="charge_seat_img" />
    </div>
    <div id="零散车位" class="pay_process" style="height: 776px">
      <div class="pay_process_back">
        <div class="head-label">
          <div class="sub_title">零散车位闲置管理</div>
          <div class="few_seat">
            <div class="few_seat_item">
              <img src="../assets/park/few_bridge.png" class="few_seat_img" />
              <div class="few_seat_item_text">高架桥下</div>
            </div>
            <div class="few_seat_item">
              <img src="../assets/park/few_alley.png" class="few_seat_img" />
              <div class="few_seat_item_text">背街小巷</div>
            </div>
            <div class="few_seat_item">
              <img src="../assets/park/few_building_out.png" class="few_seat_img" />
              <div class="few_seat_item_text">楼宇外围</div>
            </div>
            <div class="few_seat_item">
              <img src="../assets/park/few_gas_station.png" class="few_seat_img" />
              <div class="few_seat_item_text">加油站</div>
            </div>
          </div>
          <div class="few_seat_end_text">
            利用城市边角闲置空地新增零散泊位，是解决中心城区泊位供需矛盾的高效快捷手段！
          </div>
        </div>
      </div>
    </div>
    <div id="运营服务" class="pay_process" style="height: 776px">
      <div class="pay_process_back_white">
        <div class="head-label">
          <div class="sub_title">运营服务</div>
          <div class="few_seat">
            <div class="few_seat_item">
              <img src="../assets/park/operate_data.png" class="few_seat_img" />
              <div class="few_seat_item_text">数据管理</div>
            </div>
            <div class="few_seat_item">
              <img src="../assets/park/operate_pay.png" class="few_seat_img" />
              <div class="few_seat_item_text">收费管理</div>
            </div>
            <div class="few_seat_item">
              <img src="../assets/park/operate_complaint.png" class="few_seat_img" />
              <div class="few_seat_item_text">咨询投诉</div>
            </div>
            <div class="few_seat_item">
              <img src="../assets/park/operate_sequence.png" class="few_seat_img" />
              <div class="few_seat_item_text">秩序管理</div>
            </div>
          </div>
          <div class="few_seat_end_text">
            为满足停车管理公司规范运营、高效管理、专业决策、贴心服务的需求，
            运营管理中心提供数据可视化、视频监控、热线电话、运营工具等多样化方式。
          </div>
        </div>
      </div>
    </div>
    <div class="pay_process" style="height: 776px">
      <div class="pay_process_back">
        <div class="head-label">
          <div class="sub_title">典型区县初期2000路内车位24小时收费运营团队配置</div>
          <div class="solve_content">
            <img src="../assets/park/operate_team.png" class="operate_team_img" />
          </div>
          <div class="few_seat_end_text">单人月工作时长不超过210小时</div>
        </div>
      </div>
    </div>
    <div id="智能硬件" class="solve head-label">
      <el-divider direction="horizontal"></el-divider>
      <div class="title">产品中心</div>
      <div class="sub_title">路侧AI值守收费——降本增收效益显著</div>
    </div>
    <div class="solve_content">
      <img src="../assets/park/product_hardware.png" class="product_hardware_img" />
    </div>
    <div id="软件平台" class="pay_process" style="height: 624px">
      <div class="pay_process_back">
        <div class="head-label">
          <div class="sub_title" style="margin-top: 60px; font-weight: 600">
            城市级智慧停车综合管理系统
          </div>
          <div class="solve_content">
            <img src="../assets/park/soft_g.png" class="soft_img" />
            <img src="../assets/park/soft_b.png" class="soft_img" />
            <img src="../assets/park/soft_c.png" class="soft_img" />
          </div>
          <div class="software_induction">
            领泊悦行SaaS云服务系统基于分布式微服务技术架构构建，支持路内路外各类停车场统一平台管理，支持地磁、
            智能驻车器、高低位视频、视频道闸、巡检车等智能停车硬件，为停车管理公司提供数据可视化、移动管理端等多样化工具，为政府治理通过数据中台化赋能数据应用，
            为市民出行提供一站式服务。
          </div>
        </div>
      </div>
    </div>
    <!-- <div id="业务合作" class="solve head-label">
      <div class="sub_title" style="margin-top: 60px; font-weight: 600">
        50+项知识产权形成行业内研发制造优势
      </div>
    </div>
    <div class="solve_content" style="height: 790px">
      <img src="../assets/park/knowledge_rights.png" class="knowledge_rights_img" />
      <div class="few_seat_end_text" style="margin-bottom: 10px">
        50+项知识产权，其中4项发明专利已授权，多项发明专利实审中
      </div>
      <div class="few_seat_end_text">
        车检器、车辆底盘保护结构、车辆防逃逸冲撞结构等关键技术全部自研并获得国家知识产权局专利授权
      </div>
    </div> -->
    <div id="关于我们" class="pay_process about_us">
      <div class="about_content">
        <div class="about_content_left">
          <div class="left_text">咨询热线</div>
          <div class="left_text_phone">400-835-0508     025-52760630</div>
          <div class="left_text">工作时间：工作日9:00~12:00，13:00~17:00</div>
          <div class="left_text">单位地址：南京市江宁区东吉大道1号江苏软件园</div>
          <a style="font-size: 13px;color: burlywood;" href="https://beian.miit.gov.cn" target="_blank">苏ICP备2022008541号 </a>
        </div>
        <div class="about_content_right">
          <img src="../assets/park/qr_code.jpg" class="qr_code_img" />
        </div>
      </div>
      <div class="company_name">
        <span style="margin-left: -31%">Copyright 南京领泊悦行物联网有限公司</span>
      </div>
    </div>
    <div style="width: 100%; height: 100%">
      <el-backtop :bottom="60"></el-backtop>
    </div>
  </div>
</template>
<script>
export default {
  name: "Index",
  data() {
    return {
      tabName: "first",
    };
  },
  methods: {},
  mounted() {},
  computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        return "550px";
      } else {
        return "250px";
      }
    },
  },
};
</script>

<style scoped>
.view {
  margin: auto;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--vt-c-bg);
  transition: background-color 0.5s;
  padding-top: var(--vt-banner-height);
}
.border_parent {
  height: 560px;
  text-align: center;
}

.solve {
  margin-top: 30px;
  margin-bottom: 10px;
}

.solve_content {
  position: relative;
  width: 100%;
  text-align: center;
}
.border_one {
  margin-left: 0;
}

.border_img_parent {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.product_mobile_content {
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.product_mobile_img {
  width: 50%;
}

.product_mobile_title {
  font-weight: bold;
  text-align: center;
}

.product_pc_one {
  text-align: center;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.font_size_30 {
  font-size: 1.875em;
}

.product_font_style {
  font-size: 1.125em;
}

.product_pc_img {
  width: 100%;
}

.product_pc_img_div {
  width: 50%;
  float: left;
  display: flex;
  align-items: center;
}

.product_pc {
  display: flex;
  width: 90%;
  margin: 20px auto;
  background: #f2f6fc;
  align-items: center;
}

.product_spec_title {
  margin-top: 30px;
  margin-bottom: 10px;
}

.product_spec_parent {
  display: flex;
  width: 90%;
  margin: 20px auto;
  align-items: center;
  height: auto;
}

.cooperation_parent {
  display: flex;
  justify-content: center;
  width: 90%;
  margin: 20px auto;
  align-items: center;
  height: auto;
}

.border_spec {
  border-radius: 6px;
  border: 1px solid #ebeef5;
  float: left;
  width: 25%;
  height: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.about_me_p {
  font-size: 1.25em;
  font-weight: normal;
  padding: 0 20px;
  margin: 10px;
}

.border_title {
  font-family: "PingFang SC";
  margin-top: 10px;
  font-size: 1.125em;
  font-weight: bold;
  text-align: center;
}

.border_content_one {
  margin-top: 20px;
  font-size: 1.125em;
  text-align: center;
}

.border_content_two {
  margin-top: 5px;
  font-size: 1.125em;
  margin-bottom: 25px;
  text-align: center;
}

.img_border {
  margin-top: 15px;
  width: 80px;
  height: 80px;
}

.border_spec_inner_one {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 35px;
  height: 70px;
}

.border_spec_content_one {
  margin-top: 15px;
  font-size: 1.125em;
  float: left;
  text-align: center;
}

.border_spec_inner_last {
  margin-top: 15px;
  font-size: 1.125em;
  float: left;
  margin-bottom: 25px;
  text-align: center;
}

.cooperation {
  margin-top: 30px;
  width: 100%;
}

.about_me {
  display: flex;
  margin-top: 30px;
  justify-content: center;
  width: 100%;
}

.product_mobile {
  width: 90%;
  align-items: center;
  margin: 20px auto;
  background: #f2f6fc;
}

.product_mobile_img_div {
  width: 50%;
  height: auto;
}

.product_mobile_content_one {
  margin-top: 20px;
  text-align: center;
}

.product_mobile_content_two {
  margin-top: 10px;
  text-align: center;
}

.border_spec_img {
  width: 75px;
  height: 55px;
  align-self: center;
}

.title {
  font-weight: 600;
  font-family: PingFangSC-Semibold;
  color: #000000;
  text-align: center;
  font-size: 1.5em;
}
.sub_title {
  margin-top: 24px;
  font-family: PingFangSC-Regular;
  font-size: 20px;
  color: #000000;
  text-align: center;
  line-height: 50px;
}

.top_back_img {
  width: 1530px;
  height: 100%;
  margin: auto;
}
.top_back_num {
  position: relative;
  width: 1530px;
  height: 146px;
  background: rgba(33, 33, 33, 0.48);
  margin: -146px auto 0px auto;
}
.border_parent {
  width: 90%;
  margin: auto;
}
.border {
  display: flex;
  vertical-align: middle;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  height: 100%;
  margin: 0px 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.border_title {
  display: flex;
  flex-direction: row;
  justify-content: center;
  place-items: flex-end;
}
.border_title_one {
  font-family: HelveticaNeue-Bold;
  font-size: 40px;
  color: #ff7323;
  text-align: center;
  line-height: 50px;
  font-weight: 800;
}
.border_title_two {
  font-family: HelveticaNeue-Bold;
  font-size: 20px;
  color: #ff7323;
  text-align: center;
  line-height: 40px;
}
.border_content {
  font-family: PingFangSC-Regular;
  font-size: 17px;
  color: #ffffff;
  text-align: center;
  line-height: 25px;
}
.pay_process {
  position: relative;
  width: 1530px;
  height: 801px;
  display: flex;
  margin: auto;
}
.pay_process_back {
  width: 100%;
  height: 100%;
  background: #f8f9fb;
}
.pay_process_back_white {
  width: 100%;
  height: 100%;
}
.el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}
.el-tabs__header {
  display: flex !important;
  justify-content: center !important;
}
/deep/ .el-tabs__header {
  display: flex !important;
  justify-content: center !important;
}
/deep/ .el-tabs__item {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666666;
  text-align: center;
}
/deep/ .el-tabs__nav {
  display: flex;
  justify-content: space-around;
  width: 440px;
  margin-top: 24px;
}
/deep/ .el-tabs__active-bar {
  display: none;
}
/deep/ .el-tabs__active-bar {
  width: 400px;
}
.stop_process_img {
  height: 520px;
  width: 670px;
  margin-top: 60px;
}
.duty_charge_img {
  height: 477px;
  width: 877px;
  margin-top: 60px;
}
/deep/ .el-tab-pane {
  text-align: center;
}
.system_framework_img {
  width: 751px;
  height: 496px;
  margin: auto auto 24px auto;
  text-align: center;
}
.charge_seat {
  width: 1530px;
  height: 1272px;
  text-align: center;
  margin: auto;
}
.charge_seat_img {
  width: 1530px;
  height: 1272px;
}
.few_seat {
  width: 826px;
  margin: 12px auto auto auto;
  height: 530px;
  display: flex;
  flex-wrap: wrap;
  text-align: center;
}
.few_seat_img {
  width: 424px;
  height: 264px;
}
.few_seat_item {
  width: 387px;
  height: 270px;
}
.few_seat_item_text {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #222222;
  margin-left: 40px;
  margin-top: -15px;
}
.few_seat_end_text {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #222222;
  text-align: center;
  margin-top: 30px;
}
.operate_team_img {
  width: 910px;
  height: 465px;
  margin: 54px auto 24px auto;
  text-align: center;
}
/deep/ .el-divider {
  height: 5px;
  background: #006fff;
  width: 32px;
  margin: auto auto 24px auto;
}
.product_hardware_img {
  width: 1530px;
  height: 661px;
  margin: 24px auto auto auto;
  text-align: center;
}
.soft_img {
  width: 268px;
  height: 320px;
}
.software_induction {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #222222;
  line-height: 24px;
  margin: auto;
  width: 760px;
  text-indent: 2em;
}
.knowledge_rights_img {
  width: 726px;
  height: 465px;
  margin: 24px auto 48px auto;
  text-align: center;
}
.about_us {
  background: #1a1e2e;
  height: 220px;
  flex-direction: column;
}
.company_name {
  background: #262a3a;
  font-family: PingFangSC-Semibold;
  font-size: 10px;
  color: #a7a7a7;
  letter-spacing: 0.5px;
  height: 42px;
  position: absolute;
  width: 100%;
  bottom: 0px;
  align-items: center;
  display: flex;
  justify-content: space-around;
}
.about_content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 80%;
  width: 100%;
}
.about_content_left{
  width: 21%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
}
.about_content_right{
  width: 21%;
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
}
.left_text{
  font-family: PingFangSC-Medium;
  font-size: 10px;
  color: #FFFFFF;
  letter-spacing: 0.5px;
  line-height: 20px;
}
.left_text_phone{
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #099EFF;
  letter-spacing: 0.86px;line-height:22px;
}
.qr_code_img{
  width:116px;
  height: 116px;
}
/deep/ .el-menu-item{
  font-family: PingFangSC-Regular;
}
/deep/ .el-tabs__nav-wrap::after{
  display: none;
}
/deep/ .el-tabs__item{
  width: 262px;
}
/deep/ .is-active{
  width: 262px;
  border-bottom: 2px solid;
  color: #005bff;

}
</style>
